import moment from "moment";

export const toFormatDate = (
    stringDate: string | number,
    momentFormat = "DD/MM/YYYY  k:mm:ss"
) => {
    let date = moment(stringDate);
    return date.format(momentFormat);
};

/**
 * For a date that may reach us as UTC without saying so (the last maintenance and emptying of the
 * board v2, as long as the deployed API serves them as text): a plain moment() would read it as
 * local time and show it hours off. A date that does carry its time zone keeps it.
 */
export const toFormatUtcDate = (stringDate: string, momentFormat = "DD/MM/YYYY  k:mm:ss") =>
    moment.utc(stringDate).local().format(momentFormat);
